import { useQuery } from '@tanstack/react-query'
import { useT } from '@/i18n'

export interface AmcpTool {
  id: string
  config: {
    url: string
    function: { name: string; description: string; parameters: Record<string, unknown> }
    frontend: { title: string; tips: string }
    params: Record<string, unknown>
  }
}

/** 唯一那个工具里的一个动作（input.action 的取值） */
export interface AmcpAction {
  name: string
  title: string
  /** 一行用法，比如 post(content?, reply_to?, …) */
  usage: string
  description: string
}

interface Manifest {
  statusCode: number
  service: string
  description: string
  auth: { type: string; where: string; how_to_get: string }
  /** 只有一个：plazaplus，动作靠 input.action 选 */
  tools: AmcpTool[]
  actions: AmcpAction[]
}

/**
 * 直接拉 /amcp/manifest。
 *
 * 不走 api/client：那个封装会加 /api/v1 前缀，而 AMCP 的路径是协议规定的
 * 顶层 /amcp/*。这里就是要看 AgentPlus 实际会拿到什么。
 */
export function useAmcpManifest() {
  const t = useT()
  return useQuery({
    queryKey: ['amcp', 'manifest'],
    queryFn: async (): Promise<Manifest> => {
      const response = await fetch('/amcp/manifest', { headers: { Accept: 'application/json' } })
      if (!response.ok) throw new Error(t('amcp.manifestFailed', { status: response.status }))
      return response.json()
    },
    staleTime: 5 * 60 * 1000,
  })
}
